import React, { useState } from 'react';
import { Plus, Phone } from 'lucide-react';
import { faqGroups } from '../data/faqs';
export function Faq() {
  const [openQuestion, setOpenQuestion] = useState<string | null>(faqGroups[0].faqs[0].question);
  return <section id="faq" className="py-20 md:py-24 bg-slate-100 border-y border-slate-200" data-id="element-128" data-mp="1lc1zxc2r31qn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129" data-mp="1geiiy4eo4av0">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] gap-12 lg:gap-16 items-start" data-id="element-130" data-mp="2dzeofrsh1jml">
          {/* Side header */}
          <div className="lg:sticky lg:top-28" data-id="element-131" data-mp="28za4tsw9o8s5">
            <span className="text-xs font-bold tracking-widest uppercase text-brand-700" data-id="element-132" data-mp="241h074am3mtz">
              Common Questions
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-900 mt-3 mb-4 leading-tight" data-id="element-133" data-mp="1z2xd30ka8501">
              California Mesothelioma FAQ
            </h2>
            <p className="text-slate-600 leading-relaxed mb-8" data-id="element-134" data-mp="nmywmbmrygos">
              Clear, direct answers to the questions asbestos victims and their
              families ask most about filing a claim in California.
            </p>

            <div className="bg-brand-900 rounded-xl p-6" data-id="element-135" data-mp="ug9b5uqywcc4">
              <p className="text-brand-100 text-sm leading-relaxed mb-4" data-id="element-136" data-mp="fkjmfouedl3p">
                Still have questions? Speak with a California mesothelioma
                attorney today — free and confidential.
              </p>
              <a href="tel:805-770-9317" className="inline-flex items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-brand-900 px-5 py-3 rounded-md font-bold transition-colors" data-id="element-137" data-mp="6qohohx6twol">
                <Phone className="w-4 h-4" data-id="element-138" data-mp="3swtqavo3t6ws" />
                (805) 770-9317
              </a>
            </div>
          </div>

          {/* Grouped accordions */}
          <div className="space-y-10" data-id="element-139" data-mp="3jyi373mg4r93">
            {faqGroups.map(group => <div key={group.title} data-id="element-140" data-mp="3nyihmo9jp2g5">
                <h3 className="text-xl font-serif font-bold text-brand-900 mb-4" data-id="element-141" data-mp="3o1o4dwupbs8p">
                  {group.title}
                </h3>

                <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-200 overflow-hidden" data-id="element-142" data-mp="1ppmcuz77oocv">
                  {group.faqs.map(faq => {
                const isOpen = openQuestion === faq.question;
                const panelId = `faq-${faq.question.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
                return <div key={faq.question} data-id="element-143" data-mp="28hf8z2hkupot">
                        <h4 data-id="element-144" data-mp="23gzrpzu6cy1k">
                          <button type="button" onClick={() => setOpenQuestion(isOpen ? null : faq.question)} aria-expanded={isOpen} aria-controls={panelId} className="w-full flex items-start justify-between gap-6 text-left px-6 py-5 hover:bg-slate-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500" data-id="element-145" data-mp="23g80t2bivohm">
                            <span className="font-serif text-lg font-bold text-brand-900 leading-snug" data-id="element-146" data-mp="38o0ra33bmxop">
                              {faq.question}
                            </span>
                            <span className={`shrink-0 mt-0.5 w-7 h-7 rounded-full flex items-center justify-center transition-transform transition-colors duration-200 ease-out ${isOpen ? 'bg-brand-accent text-brand-900 rotate-45' : 'bg-brand-50 text-brand-700'}`} data-id="element-147" data-mp="3ifevgo67wlo6">
                              <Plus className="w-4 h-4" data-id="element-148" data-mp="1x3n9gztes44n" />
                            </span>
                          </button>
                        </h4>

                        <div id={panelId} className={`grid transition-all duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-149" data-mp="16ovyl3v6z5po">
                          <div className="overflow-hidden" data-id="element-150" data-mp="nzfuk6kasv4i">
                            <p className="px-6 pb-6 pr-14 text-slate-700 leading-relaxed" data-id="element-151" data-mp="nxlb6woodb2j">
                              {faq.answer}
                            </p>
                          </div>
                        </div>
                      </div>;
              })}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}